import { useState } from 'react';
import { TAccountLinkData, TAccountLink } from '@newo/api/gateway';
// components
import MembersTable from '@/pages/Profile/components/Members/components/MembersTable';
// utils
import { openConfirmDeleteModal } from '@/utils/ui.tsx';
import {
    useCustomerAccountLinksQuery,
    useDeleteAccountLinkMutation,
    useCreateAccountLinkMutation,
    useUpdateAccountLinkMutation
} from '@/services/customer/customer/customer.queries';

const DEFAULT_ITEMS = 10;

const Members = () => {
    const [page, setPage] = useState(1);
    const [per, setPer] = useState(DEFAULT_ITEMS);

    const { data, refetch, isLoading, isSuccess } =
        useCustomerAccountLinksQuery({ page, per });

    const metadata = data?.metadata;
    const isShowPagination = metadata && metadata.total > metadata.per;
    const totalCount = metadata ? Math.ceil(metadata.total / metadata.per) : 0;

    const { mutateAsync: deleteAccountLink } = useDeleteAccountLinkMutation();
    const { mutateAsync: createAccountLink } = useCreateAccountLinkMutation();
    const { mutateAsync: updateAccountLink } = useUpdateAccountLinkMutation();

    const members = (data?.items ?? []).filter(
        (member) => member.role !== 'referral'
    );

    const handlePageChange = (newPage: number) => {
        setPage(newPage);
    };

    const handlePerChange = (newPer: string | null) => {
        setPer(Number(newPer));
        setPage(1);
    };

    const handleDelete = (member: TAccountLink) => {
        openConfirmDeleteModal({
            title: `Unlink ${member.email}`,
            children: <>Are you sure you want to unlink {member.email}?</>,
            confirmLabel: 'Unlink',
            onConfirm: () => {
                deleteAccountLink({
                    accountId: member.account_id
                })
                    .then(async () => refetch())
                    .catch(console.error);
            }
        });
    };

    const handleSubmit = async (
        formData: TAccountLinkData,
        accountId?: string
    ) => {
        await (accountId
            ? updateAccountLink({
                  accountId,
                  data: formData
              })
                  .then(async () => refetch())
                  .catch(console.error)
            : createAccountLink({
                  data: formData
              })
                  .then(async () => refetch())
                  .catch(console.error));
    };

    return (
        <MembersTable
            isLoading={isLoading}
            isShowPagination={isShowPagination ?? false}
            isSuccess={isSuccess}
            members={members}
            page={page}
            per={per}
            totalCount={totalCount}
            onDelete={handleDelete}
            onPageChange={handlePageChange}
            onPerChange={handlePerChange}
            onSubmit={handleSubmit}
        />
    );
};

export default Members;
